import { useMemo } from 'react';
import { useMeetingFieldsAsFilterableFields } from './custom-fields';

export const useMeetingFieldsAsFilterableField = () => {
  const { fields: meetingFields, loading: meetingFieldsLoading } =
    useMeetingFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: meetingFields,
      loading: meetingFieldsLoading,
    }),
    [meetingFields, meetingFieldsLoading],
  );
};
